import React from "react";
import About from "../about/About";
import Contact from "../contact/Contact";
import Footer from "../footer/Footer";
import Home from "../home/Home";
import Home2 from "../home/Home2";
import Myproject from "../myproject/Myproject";
import Service from "../servicee/Service";

const Protfolio = () => {
  return (
    <div
      style={{ margin: 0, padding: 0, minWidth: "100vw" }}
      className="bg-light border"
    >
      <Home></Home>
      <Home2></Home2>
      <About></About>
      <Service></Service>
      <Myproject></Myproject>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  );
};

export default Protfolio;
